import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from "@angular/core";

@Component({
  selector: "app-editor",
  templateUrl: "./app-editor.component.html",
})
export class AppEditorComponent implements OnChanges {
  @Input() elementId: string;
  @Input() dataForm: string;
  @Input() disabled: boolean;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() setContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() keyUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() dirty: EventEmitter<any> = new EventEmitter<any>();

  public settings;

  constructor() {}

  ngOnChanges() {
    this.setup(this.that);
  }

  onBlur($event) {
    this.blur.emit($event);
  }
  onChange($event) {
    this.change.emit($event);
  }

  onSetContent($event) {
    this.setContent.emit($event);
  }

  onKeyUp($event) {
    this.keyUp.emit($event);
  }

  onDirty($event) {
    this.dirty.emit($event);
  }

  that = this;

  setup(that: any) {
    this.settings = {
      disabled: this.disabled,
      readonly: this.disabled ? 1 : 0,
      selector: "#" + this.elementId,
      max_width: 1000,
      max_height: 500,
      min_height: 400,
      menubar: false,
      branding: false,
      plugins: ["link", "paste", "table", "lists", "code"],
      /*
      toolbar:
        "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | code",
        */
      skin_url: "/assets/skins/lightgray",
      paste_as_text: true,
      setup: (editor) => {
        editor.on("keydown", function (e, evt) {
          if (that.disabled) {
            if ((e.ctrlKey || e.metaKey) && (e.key === "c" || e.key === "a")) {
              return;
            } else {
              e.preventDefault();
            }
          } else {
            return;
          }
        });
        editor.on("contextmenu", function (e, evt) {
          // e.preventDefault();
        });
        editor.on("paste", function (e) {
          if (that.disabled) {
            e.preventDefault();
          } else {
            return;
          }
        });
        editor.on("change", () => {
          const content = editor.getContent();
          this.notify.emit({ id: content, type: this.elementId });
        });
      },
    };
  }
}
